module.exports = __webpack_public_path__ + "static/media/img-title-red-ball.a25cd734.png";